import Role from "./Rol";
import Campaign from "./Campaign";
import Company from "./Company";
import { AnyObject } from "types";

export interface IUser {
  id: number;
  name: string;
}

export class UserName {
  firstName = "";
  lastName = "";
  motherLastName = "";
  constructor(properties: AnyObject = {}) {
    if (properties !== null) {
      this.firstName = properties.firstName;
      this.lastName = properties.lastName;
      this.motherLastName = properties.motherLastName;
    }
  }
}

export default class User extends UserName {
  id: number;
  email: string;
  blocked: boolean;
  role: Role;
  currentCampaign: Campaign;
  company: Company;
  token = "";
  password: string;
  usersNumber: number;
  constructor(properties: AnyObject = {}) {
    super({
      firstName: properties.firstName,
      lastName: properties.lastName,
      motherLastName: properties.motherLastName,
    });
    this.id = properties.id || 0;
    this.email = properties.email || "";
    this.blocked = properties.blocked || false;
    this.role = properties.role || new Role();
    this.currentCampaign = properties.currentCampaign || new Campaign();
    this.company = properties.company || new Company();
    this.password = properties.password || "";
    this.usersNumber = properties.usersNumber || 0;
  }

  fullName(): string {
    return `${this.firstName} ${this.lastName} ${this.motherLastName || ""}`;
  }
  asJSON(): AnyObject {
    const data: AnyObject = {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      motherLastName: this.motherLastName,
      role: this.role.priority,
      companyId: this.company.id,
    };
    if (this.password.length > 0) {
      data["password"] = this.password;
    }
    return data;
  }
  isSuper(): boolean {
    return this.role.priority === 2;
  }
  isAdmin(): boolean {
    return this.role.priority === 3;
  }
  isSuperAdmin(): boolean {
    return this.role.priority === 4;
  }
}
